<div dialog-header>
  <h4>Edit Contract</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

@if (!submittedSuccess()) {
  <form [formGroup]="customerForm">
    <app-tabs class="tabs">
      <app-tab #tab1 [title]="'editContractPopup.customer' | translate">
        @if (tab1.active) {
          <div class="content">
            @if (!isMazdaProducts) {
              <app-input-radio
                label="Business?"
                formControlName="businessFlag"
                [options]="radioOptions"
                (change)="businessToggle($event)"
              />
            }
            @if (customerForm.get('businessName')?.enabled) {
              <app-input-control formControlName="businessName" label="Business Name" />
            }
            @if (customerForm.get('firstName')?.enabled) {
              <div class="edit-contract-row name-row">
                <app-input-control formControlName="firstName" label="First Name" />
                <app-input-control formControlName="middleInitial" label="M.I" [maxLength]="1" />
                <app-input-control formControlName="lastName" label="Last Name" />
              </div>
            }
            <div class="edit-contract-row address-row">
              <app-input-control formControlName="customerAddress1" label="Address" />
              <app-input-control formControlName="customerAddress2" label="Suite/Apt" />
            </div>
            <div class="edit-contract-row">
              <app-input-control formControlName="customerPostalCode" label="Postal Code" />
              <app-input-control formControlName="customerCity" label="City" [readOnly]="autoFill" />
              <app-input-control formControlName="customerStateProvince" label="State/Province" [readOnly]="autoFill" />
            </div>
            <div class="edit-contract-row">
              <app-input-control formControlName="customerPhone1" label="Phone 1" [maxLength]="10" />
              <app-input-control formControlName="customerPhone2" label="Phone 2" [maxLength]="10" />
            </div>
            <app-input-control formControlName="customerEmail" label="Email" type="email" />
          </div>
        }
      </app-tab>
      <app-tab #tab2 [title]="'editContractPopup.cosigner' | translate">
        @if (tab2.active) {
          <div class="content">
            <app-input-radio
              label="Cosigner?"
              formControlName="cosignerFlag"
              [options]="radioOptions"
              (change)="setCosignerToggle($event)"
            />
            <div class="edit-contract-row name-row">
              <app-input-control formControlName="cosignerFirstName" label="First Name" />
              <app-input-control formControlName="cosignerMiddleName" label="M.I" [maxLength]="1" />
              <app-input-control formControlName="cosignerLastName" label="Last Name" />
            </div>
            <div class="edit-contract-row address-row">
              <app-input-control formControlName="cosignerAddress1" label="Address" />
              <app-input-control formControlName="cosignerAddress2" label="Suite/Apt" />
            </div>
            <div class="edit-contract-row">
              <app-input-control formControlName="cosignerPostalCode" label="Postal Code" />
              <app-input-control formControlName="cosignerCity" label="City" [readOnly]="autoFill" />
              <app-input-control formControlName="cosignerStateProvince" label="State/Province" [readOnly]="autoFill" />
            </div>
            <div class="edit-contract-row">
              <app-input-control formControlName="cosignerPhone1" label="Phone 1" [maxLength]="10" />
              <app-input-control formControlName="cosignerPhone2" label="Phone 2" [maxLength]="10" />
            </div>
            <app-input-control formControlName="cosignerEmail" label="Email" type="email" />
          </div>
        }
      </app-tab>
      <app-tab #tab3 [title]="'editContractPopup.lienholder' | translate">
        @if (tab3.active) {
          <div class="content">
            <div class="lienholder-input">
              @if (!selectedLienholder() && lienholderControl.touched) {
                <span class="error">*required</span>
              }
              <p class="label">Lienholder</p>
              <input
                ui-input
                [formControl]="lienholderControl"
                [appAutocomplete]="autocomplete"
                [invalid]="!!lienholderControl.errors"
              />
              <app-autocomplete #autocomplete="appAutocomplete">
                <ng-template appAutocompleteContent>
                  @if (filteredLienholders() | appAutocompleteFilter: lienholderControl.value; as result) {
                    @for (option of result; track option) {
                      @if (option.status) {
                        <app-option [value]="option.name" (optionClicked)="setSelectedLienholderOption(option)">
                          {{ option?.name }} - {{ option?.address1 }} {{ option?.city }}
                        </app-option>
                      }
                    }
                  }
                </ng-template>
              </app-autocomplete>
            </div>
          </div>
        }
      </app-tab>
    </app-tabs>
  </form>
} @else {
  <p class="success-text">Your contract was updated successfully!</p>
}

<div dialog-actions>
  @if (!submittedSuccess()) {
    <button ui-button (click)="editContract()" [disabled]="!customerForm.valid || !contractUpdated()">Update</button>
  }
  <button ui-button [type]="submittedSuccess() ? 'success' : 'danger'" (click)="close()">
    {{ submittedSuccess() ? 'Close' : 'Cancel' }}
  </button>
</div>
